import React, { useState, useContext, useEffect } from 'react';
import './UserList.css';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import AuthContext from './AuthContext';

const UserList = () => {
  
  const navigate = useNavigate();
  const { customerId } = useParams();
  const { user } = useContext(AuthContext);
  const { dataUsers } = useOutletContext(); // Access dataUsers from UserLayout context
  const [showActive, setShowActive] = useState(true); // State to toggle active/inactive users

  useEffect(() => {
    // if no user in context, log them in again
    if (!user) {
      navigate('/login');
      return;
    }
    // check expiration
    const currentTime = Date.now() / 1000; // in seconds
    if (user.exp && user.exp <= currentTime) {
      // token has expired
      navigate('/login');
    }
  }, [user, navigate]);

   if (dataUsers === undefined) {
    return <div>Loading Users… </div>;
  }

  // Ensure dataUsers is valid
  if (!Array.isArray(dataUsers)) {
    console.error('Invalid dataUsers:', dataUsers);
    return <div>Error: Unable to load user data.</div>;
  }

  // Filter users
  const filteredUsers = dataUsers.filter((u) => {
    let matchesAccessLevel = false;

    if (user.access_level === 'User') {
      matchesAccessLevel = u.id === parseInt(user.id, 10);
    } else if (user.access_level === 'Admin') {
      //matchesAccessLevel = u.fkCustomer === parseInt(user.customer_id);
      matchesAccessLevel =
      user.access_level === "Admin"
        ? u.fkCustomer === parseInt(user.customer_id) || u.customer_Name // Include users with customer names
        : true; // Higher levels see all

    } else {
      matchesAccessLevel = true; // Allow all for higher access levels
    }

    const matchesActiveFilter = showActive
      ? u.active?.toUpperCase() === 'YES'
      : u.active?.toUpperCase() === 'NO';

    return matchesAccessLevel && matchesActiveFilter;
  });

  const toggleStatusFilter = () => setShowActive((prev) => !prev);

  const handleViewDetails = (userIdManage) => {
    const url = `/customer/${customerId}/user/manage/${userIdManage}`;
    const newTab = window.open(url, '_self');
    //newTab.focus(); // Optionally bring the new tab into focus
  };
  const handleCreate = () => {

    const url = `/customer/${customerId}/user/manage/new`;
    //const newTab = window.open(url, '_self');
    navigate(`/customer/${customerId}/user/manage/new`);

  }

  return (
    <div className="user-list-container">
      <h1>{showActive ? 'Active Users' : 'Inactive Users'}</h1>
      <button onClick={toggleStatusFilter} className="toggle-button">
        {showActive ? 'Show Inactive Users' : 'Show Active Users'}
      </button>
      <table className="user-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Title</th>
            <th>Email</th>
            <th>Login</th>
            <th>Access</th>
            <th>Customer</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map((userManage) => (
            <tr key={userManage.id}>
              <td>{userManage.person_Name || 'N/A'}</td>
              <td>{userManage.title || 'N/A'}</td>
              <td>{userManage.email || 'N/A'}</td>
              <td>{userManage.login || 'N/A'}</td>
              <td>{userManage.role_Name || 'N/A'}</td>
              <td>{userManage.customer_Name || 'N/A'}</td>
              <td>
                <button
                  onClick={() => handleViewDetails(userManage.id)}
                  className="user-detail-link"
                >
                  View Details
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div>
        { (user?.role_name == "Admin" || user?.role_name == "SuperAdmin" ) ? (
          <button
            onClick={() => handleCreate()}
            className="user-create-link"
            >
                  Create New User
          </button>
          ) : (
          <div></div>
          )}
      </div>
    </div>
  );
};

export default UserList;
